/* ui/game/Turn.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "svelte/internal";

import { turnStore } from "../store";

function create_fragment(ctx) {
	let label;
	let t1;
	let data;
	let t2;

	return {
		c() {
			label = element("label");
			label.textContent = "Turn:";
			t1 = space();
			data = element("data");
			t2 = text(/*$turnStore*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, label, anchor);
			insert(target, t1, anchor);
			insert(target, data, anchor);
			append(data, t2);
		},
		p(ctx, [dirty]) {
			if (dirty & /*$turnStore*/ 1) set_data(t2, /*$turnStore*/ ctx[0]);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(label);
			if (detaching) detach(t1);
			if (detaching) detach(data);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $turnStore;
	component_subscribe($$self, turnStore, $$value => $$invalidate(0, $turnStore = $$value));
	return [$turnStore];
}

class Turn extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Turn;